import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManageEntityLocationComponent } from './manage-entity-location.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { TooltipModule } from 'ngx-bootstrap';

@NgModule({
  declarations: [ManageEntityLocationComponent],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    TooltipModule.forRoot()
  ],
  exports: [ManageEntityLocationComponent],
  entryComponents: [ManageEntityLocationComponent]
})
export class ManageEntityLocationModule { }
